import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import Stepper from './stepper'
import DropzoneAvatar from '@/components/share/dropzone_avatar'
import DropzonePage from '@/components/share/dropzone_page'
const Validator = require('validatorjs')
Validator.useLang('ja')

export default {
  name: 'step-3',
  components: {
    SharedHeader,
    SharedFooter,
    Stepper,
    DropzoneAvatar,
    DropzonePage
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    env () {
      return this.$store.getters.env
    }
  },
  data () {
    return {
      loading: false,
      updating: {
        avatar: false,
        cover: false
      },
      error: {},
      isAlert: false,
      step: 1,
      avatar: {
        isAvatar: false,
        isUpload: false,
        avatarId: ''
      },
      cover: {
        isUpload: false,
        coverId: ''
      }
    }
  },
  mounted () {
    this.loading = false
  },
  methods: {
    updateProfile () {
      this.updating = true

      if (!this.isAgree) {
        this.error.message = '利用規約に同意してください'
        this.isAlert = true
        window.scrollTo(0, 0)
        this.updating = false
      } else {
        this.isAlert = false

        let additionalParams = {
          queryParams: {
            type: 'terms'
          }
        }

        let body = {
          trigger: this.trigger,
          objective: this.objective
        }

        this.$apig.patch(this.api.REGISTER, {}, additionalParams, body)
          .then(response => {
            this.$router.push({
              path: '/register/complete',
              query: this.$route.query
            })
          })
          .catch(err => {
            console.log(err)
            this.error = err.response.data
            this.isAlert = true
            window.scrollTo(0, 0)
            this.updating = false
          })
      }
    },
    getDropzoneData (data) {
      this.updating.avatar = true
      setTimeout(() => {
        this.avatar.isUpload = data.isUpload
        this.avatar.avatarId = data.avatarId
        this.$store.commit('onAvatarStateChanged', data.avatarId)
        this.updating.avatar = false
      }, 1000)
    },
    getDropzoneCoverData (data) {
      this.updating.cover = true
      setTimeout(() => {
        this.cover.coverId = data.coverId
        this.cover.isUpload = false
        this.updating.cover = false
      }, 1000)
    },
    getAvatar (avatarId) {
      return `${this.env.S3}/enterprise/avatar/${avatarId}.png`
    },
    getCover (coverId) {
      return `${this.env.S3}/enterprise/cover/${coverId}.png`
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/register/step-3/step-3.js